export default function IconSignUp() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 2.5L4.16667 2.5C3.72464 2.5 3.30072 2.6756 2.98816 2.98816C2.6756 3.30072 2.5 3.72464 2.5 4.16667L2.5 15.8333C2.5 16.2754 2.6756 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5L7.5 17.5"
        stroke="#474747"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 14.1667L7.49999 10L11.6667 5.83335"
        stroke="#474747"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 10L17.5 10"
        stroke="#474747"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
